exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sourcePanel {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  width: 60%;\n  background: #1D1E22;\n  color: rgba(255, 255, 255, 0.9);\n  display: flex;\n  flex-direction: column; }\n  .sourcePanel .panelTitle {\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05); }\n", ""]);

// exports
